import $lodash from 'lodash'

const types = {
  SET_OPTION_DATA: 'speedCalculation/SET_OPTION_DATA',
  SET_SELECTED_DATA: 'speedCalculation/SET_SELECTED_DATA',
  UPDATE_SELECTED_DATA: 'speedCalculation/UPDATE_SELECTED_DATA',
  RESET_SELECTED_DATA: 'speedCalculation/RESET_SELECTED_DATA',
  UPDATE_REQUIRE_CHECK_DATA: 'speedCalculation/UPDATE_REQUIRE_CHECK_DATA',
  ADD_COMPARE_DATA: 'speedCalculation/ADD_COMPARE_DATA',
  REMOVE_COMPARE_DATA: 'speedCalculation/REMOVE_COMPARE_DATA',
  TOGGLE_COMPARE_CHART_DISPLAY: 'speedCalculation/TOGGLE_COMPARE_CHART_DISPLAY',
  CLONE_SELECTED_DATA: 'speedCalculation/CLONE_SELECTED_DATA',
  SET_IS_FROM_GUIDE: 'speedCalculation/SET_IS_FROM_GUIDE',
  UPDATE_CALCULATION_RESULT: 'speedCalculation/UPDATE_CALCULATION_RESULT'
}

// 預設的空選項
const defaultOptions = () => {
  return {
    flv_second: [],
    freq: 2,
    demographics: {
      male: [],
      female: []
    },
    hourlies: [],
    interests: [],
    keywords: [],
    medias: {
      categories: []
    },
    cities: {
      regions: [],
      municipalities: []
    },
    isps: [],
    device_brands: []
  }
}

// 預設的空選擇資料
const defaultSelectedData = () => {
  return {
    playDate: [],
    flvSecond: 1,
    frequency: 2,
    demographics: [],
    hourlies: [],
    interestKeyword: {
      type: 'interest',
      interestIds: [],
      keywordIds: []
    },
    media: {
      isPrime: 0,
      includeIds: [],
      excludeIds: []
    },
    platformType: 'speedDmp',
    cities: {
      regions: [],
      municipalities: []
    },
    isps: [],
    deviceBrands: [],
    budgetReach: {
      type: 'budget',
      minimumBudget: 0,
      budget: {
        value: 0,
        format: {}
      },
      reach: {
        value: 50,
        format: {}
      }
    },
    condition: {
      // speed 固定帶給後端的資料
      placement_type_id: 2
    }
  }
}

// 選項必填檢查
const defaultRequireCheckList = () => {
  return {
    flvSecond: false,
    frequency: false,
    demographics: false,
    hourlies: false,
    interestKeyword: false,
    media: false,
    cities: false,
    isps: false,
    deviceBrands: false,
    budgetReach: false,
    playDate: false,
    platformType: false
  }
}

const state = {
  options: defaultOptions(),
  selectedData: defaultSelectedData(),
  calculationResult: null,
  requireCheckList: defaultRequireCheckList(),
  compareDataLimit: 10, // 比較上限
  compareDataList: [],
  isFromGuide: false
}

const getters = {
  // 檢查所有選項是否都通過必填檢驗
  requireAllPass: (state, getters, rootState, rootGetters) => {
    return Object.values(state.requireCheckList).every(warningText => !warningText) &&
           rootState.root.baseInfoChecked === true
  },
  // 判斷是否已達比較上限
  isCompareDataLimit: state => state.compareDataList.length >= state.compareDataLimit
}

const actions = {
  // 設定選項
  setOptions ({ commit }, data) {
    commit(types.SET_OPTION_DATA, data)
  },
  // LOAD FAVORITE DATA AND THEN USE IT
  setSelectedData ({ commit }, data) {
    commit(types.SET_SELECTED_DATA, data)
  },
  // 更新選擇資料
  updateSelectedData ({ commit }, data) {
    commit(types.UPDATE_SELECTED_DATA, data)
  },
  // 清空選擇資料
  // 但如果是 agency 或 client，要再設定代理商名或是客戶名
  resetSelectedData ({ commit, dispatch }) {
    commit(types.RESET_SELECTED_DATA)
    dispatch('root/resetSelectedData', null, { root: true })
  },
  // 更新欄位檢查狀態
  updateRequireCheckData ({ commit }, data) {
    commit(types.UPDATE_REQUIRE_CHECK_DATA, data)
  },
  // 新增比較
  addCompareData ({ commit }, data) {
    commit(types.ADD_COMPARE_DATA, data)
  },
  // 移除比較
  removeCompareData ({ commit }, index) {
    commit(types.REMOVE_COMPARE_DATA, index)
  },
  // 切換該index比較圖表顯示/隱藏
  toggleCompareChartDisplay ({ commit }, index) {
    commit(types.TOGGLE_COMPARE_CHART_DISPLAY, index)
  },
  cloneSelectedData ({ commit }, data) {
    commit(types.CLONE_SELECTED_DATA, data)
  },
  setIsFromGuide ({ commit }, data) {
    commit(types.SET_IS_FROM_GUIDE, data)
  },
  updateCalculationResult ({ commit }, data) {
    commit(types.UPDATE_CALCULATION_RESULT, data)
  }
}

const mutations = {
  [types.SET_OPTION_DATA] (state, data) {
    Object.assign(state.options, data)
  },
  [types.SET_SELECTED_DATA] (state, data) {
    state.selectedData = data
  },
  [types.UPDATE_SELECTED_DATA] (state, data) {
    const cloneData = $lodash.cloneDeep(data)
    cloneData.forEach(item => {
      $lodash.set(state.selectedData, item.key, item.value)
    })
  },
  [types.CLONE_SELECTED_DATA] (state, data) {
    state.selectedData = $lodash.cloneDeep(data)
  },
  [types.RESET_SELECTED_DATA] (state) {
    state.selectedData = defaultSelectedData()
  },
  [types.UPDATE_REQUIRE_CHECK_DATA] (state, data) {
    const cloneData = $lodash.cloneDeep(data)
    state.requireCheckList[cloneData.key] = cloneData.value
  },
  [types.ADD_COMPARE_DATA] (state, data) {
    data.display = true
    state.compareDataList.push(data)
  },
  [types.TOGGLE_COMPARE_CHART_DISPLAY] (state, index) {
    state.compareDataList[index].display = !state.compareDataList[index].display
  },
  [types.REMOVE_COMPARE_DATA] (state, index) {
    state.compareDataList.splice(index, 1)
  },
  [types.SET_IS_FROM_GUIDE] (state, data) {
    state.isFromGuide = data
  },
  [types.UPDATE_CALCULATION_RESULT] (state, data) {
    state.calculationResult = $lodash.cloneDeep(data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
